export default {
      id: "nuit-avec-averses-usage",
      viewBox: "0 0 91 91",
      url: "../dist/images/" + "sprite.svg#nuit-avec-averses-usage",
      toString: function () {
        return this.url;
      }
    }